export default __webpack_public_path__ + "static/media/tube-4-h-en.4f482e26.svg";